export default {
  // Endpoints
  loginEndpoint: process.env.VUE_APP_AUTH_URL + "/auth/",
  registerEndpoint: '/jwt/register',
  refreshEndpoint: process.env.VUE_APP_AUTH_URL + "/auth/refreshToken/",
  logoutEndpoint: '/jwt/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
